import { createFileRoute, redirect } from '@tanstack/react-router'
import { PaymentFormScreen } from '@/features/accounting-payments/payment-form-screen'
import { hasGrant } from '@/lib/me'

/**
 * Route shell for creating a payment.
 *
 * The grant guard is presentation only. The API enforces
 * `accounting_payment.create` on POST /accounting/payments, so a stale grant
 * still 403s server-side; this keeps a user without it out of a screen they
 * cannot use.
 */
export const Route = createFileRoute('/_authenticated/accounting/payments/new')({
  beforeLoad: ({ context }) => {
    if (!hasGrant(context.queryClient, 'accounting_payment.create')) {
      throw redirect({ to: '/accounting/payments' })
    }
  },
  component: PaymentFormScreen,
})
